import React, { useEffect, useState } from "react";
import { Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const FIELDS = [
  { k: "rav_red", l: "Rouge si reste à vivre / personne <", u: "€" },
  { k: "rav_orange", l: "Orange si reste à vivre / personne <", u: "€" },
  { k: "endettement_red", l: "Rouge si endettement après projet >", u: "%" },
];

export default function RavThresholdsEditor() {
  const [v, setV] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/configuration/rav-thresholds").then((r) => setV(r.data)).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { setV((await api.put("/configuration/rav-thresholds", v)).data); toast.success("Seuils enregistrés"); } catch { toast.error("Échec"); } finally { setBusy(false); }
  };
  return (
    <div className="card-flat p-5" data-testid="rav-thresholds-editor">
      <h3 className="font-heading text-lg font-medium text-norea-text">Seuils du reste à vivre</h3>
      <p className="text-xs text-norea-textMuted mt-0.5 mb-3">Voyant vert / orange / rouge affiché dans Synthèse &gt; Reste à vivre.</p>
      {v && (
        <div className="space-y-2">
          {FIELDS.map((f) => (
            <label key={f.k} className="flex items-center justify-between gap-3 text-sm">
              <span>{f.l}</span>
              <span className="inline-flex items-center gap-1">
                <input type="number" value={v[f.k]} onChange={(e) => setV({ ...v, [f.k]: parseFloat(e.target.value) || 0 })} className="input-field w-24 text-right text-sm" data-testid={`rav-th-${f.k}`} /> {f.u}
              </span>
            </label>
          ))}
          <button onClick={save} disabled={busy} className="btn-primary text-xs mt-2" data-testid="rav-th-save">{busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Save className="w-3 h-3" />} Enregistrer</button>
        </div>
      )}
    </div>
  );
}
